/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function SpeakerX(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M155.51465,24.81348a7.99448,7.99448,0,0,0-8.42578.87207L77.25488,80H32A16.01833,16.01833,0,0,0,16,96v64a16.01833,16.01833,0,0,0,16,16H77.25488l69.834,54.31445A7.99958,7.99958,0,0,0,160,224V32A7.9997,7.9997,0,0,0,155.51465,24.81348ZM32,96H71.9707v64H32Z" />
        <Path d="M227.31445,128l18.34278-18.34277a8.00053,8.00053,0,0,0-11.31446-11.31446L216,116.68555,197.65723,98.34277a8.00053,8.00053,0,0,0-11.31446,11.31446L204.68555,128l-18.34278,18.34277a8.00053,8.00053,0,0,0,11.31446,11.31446L216,139.31445l18.34277,18.34278a8.00053,8.00053,0,0,0,11.31446-11.31446Z" />
      </G>
    </Svg>
  );
}

export default SpeakerX;
